export class ArrayExt<T> {
  constructor(private readonly array: T[]) {}

  public remove(element: T): number {
    const index = this.array.indexOf(element);
    return this.removeIfIndexIsValid(index);
  }

  public removeLast(element: T): number {
    const index = this.array.lastIndexOf(element);
    return this.removeIfIndexIsValid(index);
  }

  public removeAll(element: T): void {
    let lastIndex = 0;
    while (lastIndex !== -1) {
      lastIndex = this.array.indexOf(element, lastIndex);
      this.removeIfIndexIsValid(lastIndex);
    }
  }

  public findAndRemove(predicate: (element: T) => boolean): number {
    const index = this.array.findIndex(predicate);
    return this.removeIfIndexIsValid(index);
  }

  public findAndRemoveAll(predicate: (element: T) => boolean): void {
    let lastIndex = 0;
    while (lastIndex !== -1) {
      lastIndex = this.array.findIndex(predicate);
      this.removeIfIndexIsValid(lastIndex);
    }
  }

  private removeIfIndexIsValid(index: number): number {
    if (index !== -1) {
      this.array.splice(index, 1);
    }
    return index;
  }

  public at(index: number): T {
    if (index >= 0) {
      return this.array[index];
    } else {
      return this.array[this.array.length + index];
    }
  }

  public get length(): number {
    return this.array.length;
  }
}

export const arrayExt = <T>(array: T[]): ArrayExt<T> => new ArrayExt<T>(array);
